module.exports = __webpack_public_path__ + "static/media/marketplace_cta.0bf87729.jpg";